import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import createMarkup from '@medscape-promo/medscapetv/utils/create-markup';
const ArrowIcon = function(){
    return (
        <svg width="17px" height="28px" viewBox="0 0 17 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-295.000000, -124.000000)" fill="#005B81">
                    <g transform="translate(309.142136, 138.142136) scale(-1, 1) rotate(-315.000000) translate(-309.142136, -138.142136) translate(299.142136, 128.142136)">
                        <rect x="2.27373675e-13" y="1.13686838e-13" width="19.5226344" height="3.48769053"></rect>
                        <polygon points="16.4683385 19.3866021 16.4683385 0.553073235 19.956029 0.553073235 19.956029 19.3866021"></polygon>
                    </g>
                </g>
            </g>
        </svg>
    )
};
function BreadcrumbLink(props){
    const { path, children, onClick, routing } = props;
    require('./breadcrumb.scss');
    if(routing === true){
        return(
            <Link className="button-link" to={path} onClick={onClick}>
                { children }
            </Link>
        )
    }
    else{
        return(
            <a href={path} className="button-link" target="_blank" rel="noreferrer" onClick={props.onClick}>
                { children }
            </a>
        )
    }
}
BreadcrumbLink.propTypes = {
    path: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func,
    routing: PropTypes.bool
}
function Breadcrumb(props) {
    const { path, onLinkClick, routing, label } = props;
    //console.log("[Breadcrumb] props:",props);
    return (
        <div className="breadcrumb">
            <div className="container">
                <span className="icon"><ArrowIcon /></span>
                <BreadcrumbLink path={path} onClick={onLinkClick} routing={routing}>
                    <span className="series-title" dangerouslySetInnerHTML={createMarkup(label)}></span>
                </BreadcrumbLink>
            </div>
        </div>
    )
}
Breadcrumb.propTypes = {
    path: PropTypes.string,
    children: PropTypes.any,
    onLinkClick: PropTypes.func,
    routing: PropTypes.bool,
    label: PropTypes.string
}




export default Breadcrumb